import { AttributeQuestionEmoji, ShareFeedbackAttribute } from "../../../type";
import { isMultiSelectScale } from "../../../util/answerUtils";
import { findExistingAttribute } from "../../../util/attributeUtils";

export const updateAttributeOnClick = (
  newValue,
  shareAssessmentData,
  setShareAssessmentData,
  emojiSelected?,
  setEmojiSelected?,
) => {
  let updatedShareFBAttribute: Array<ShareFeedbackAttribute> = [];
  let updatedEmoji: Array<AttributeQuestionEmoji> = [];
  for (let index = 0; index < newValue.length; index++) {
    const arg1: ShareFeedbackAttribute = {
      attributeId: newValue[index].id,
      attributeName: newValue[index].name,
      questions: newValue[index].questions?.map((que) => ({
        questionId: que.id,
        questionName: que.questionText,
        answer: "",
        scaleName: que.answerType,
        scaleVersion: que.scaleVersion,
      })) || [],
      context: "",
      suggestions: "",
      resources: "",
    };
    const emojiArg: AttributeQuestionEmoji = {
      attributeId: newValue[index].id,
      queEmoji: newValue[index].questions?.map((que) => ({
        questionId: que.id,
        emojiId: isMultiSelectScale(que.answerType) ? [] : -1,
      })) || [],
    };
    const existing = findExistingAttribute(shareAssessmentData, newValue[index].id);
    if (existing) {
      updatedShareFBAttribute.push(existing);
      const existingIdx = shareAssessmentData.indexOf(existing);
      if (emojiSelected) updatedEmoji.push(emojiSelected[existingIdx]);
    } else {
      updatedShareFBAttribute.push(arg1);
      updatedEmoji.push(emojiArg);
    }
  }
  setShareAssessmentData(updatedShareFBAttribute);
  if (setEmojiSelected) setEmojiSelected(updatedEmoji);
};

export const handleOnChange =
  (index, shareAssessmentData, setShareAssessmentData) => (e) => {
    let newData = [...shareAssessmentData];
    newData[index][e.target.id] = e.target.value;
    setShareAssessmentData(newData);
  };
